import Vue from 'vue'
import Router from 'vue-router'
import appConfig from '../config/app'
import mainComponent from '../components/pages/home.vue'
import categoryComponent from '../components/pages/categories/category.vue'
import pamComponent from '../components/pages/pam78/pam.vue'
import adminPam from '../components/pages/admin/adminPam/adminPam.vue'

Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            component: mainComponent,
            name: 'home'
        },
        {
            path: '/categories/:category/:network?',
            component: categoryComponent,
            name: appConfig.routes.categoryMain
        },
        {
            path: '/pam/:startDate?/:endDate?',
            component: pamComponent,
            name: 'pam'
        },
        {
            path: '/admin',
            component: () => import('../components/pages/admin/adminMain'),
            children: [
                {
                    name: 'administrationGestionUser',
                    path: 'users',
                    component: () => import('../components/pages/admin/adminUser'),
                },
                /*{
                    name: 'adminPam',
                    path: 'pam',
                    component: () => import('../components/pages/admin/adminPam'),
                }*/
            ]
        },
        {
            path: '/adminPam',
            component: adminPam,
            name: 'adminPam'
        }
    ]
})
